import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { type VariantProps } from "class-variance-authority"

import { cn } from "../../../lib/utils"
import { badgeVariants } from "./badge.variants"

export interface BadgeProps
  extends React.ComponentProps<"span">,
    VariantProps<typeof badgeVariants> {
  /**
   * If true, the badge will render as its child element
   */
  asChild?: boolean
  /**
   * Icon to display before the badge text
   */
  leadingIcon?: React.ReactNode
  /**
   * Icon to display after the badge text
   */
  trailingIcon?: React.ReactNode
}

function Badge({
  className,
  variant = "default",
  size = "md",
  asChild = false,
  leadingIcon,
  trailingIcon,
  children,
  ...props
}: BadgeProps) {
  const Comp = asChild ? Slot : "span"

  return (
    <Comp
      data-slot="badge"
      data-variant={variant}
      data-size={size}
      className={cn(badgeVariants({ variant, size, className }))}
      {...props}
    >
      {leadingIcon}
      {children}
      {trailingIcon}
    </Comp>
  )
}

Badge.displayName = 'Badge'

export default Badge
